export function awardGroupStats(programs, ungroupedId) {
  const stats = new Map();
  for (const program of programs) {
    const groupId = program.recognition_award_group_id || ungroupedId;
    if (!stats.has(groupId)) {
      stats.set(groupId, { programIds: [], activeCount: 0 });
    }
    const groupStat = stats.get(groupId);
    groupStat.programIds.push(program.recognition_award_program_id);
    if (program.is_active) {
      groupStat.activeCount += 1;
    }
  }
  return stats;
}

export function awardGroupActiveLabel({ programIds, activeCount }) {
  const total = programIds.length;
  if (activeCount === total) {
    return `${total} ${total === 1 ? 'award' : 'awards'}`;
  }
  return `${activeCount} of ${total} active`;
}
